import { api } from './client';
import type { AdminLogin, UserLogin } from './types';

export interface GuestLoginPayload {
    username: string;
    mail?: string;
    newsletter?: boolean;
    /** M5: consenso privacy obbligatorio, registrato dal server (`privacy_accepted`). */
    privacy_accepted: boolean;
    /** M5: versione del testo privacy al momento del consenso (`privacy_version`). */
    privacy_version: string;
}

export async function guestLogin(payload: GuestLoginPayload): Promise<UserLogin> {
    const { data } = await api.post<UserLogin>('/guest/login', payload);
    return data;
}

export async function adminLogin(payload: { mail: string; pass: string }): Promise<AdminLogin> {
    const { data } = await api.post<AdminLogin>('/admin/login', payload);
    return data;
}

export async function registerAdmin(payload: { name: string; mail: string; pass: string }) {
    const { data } = await api.post('/admin/register', payload);
    return data;
}

/**
 * M4: azzera il cookie di autenticazione lato server. La sessione locale va
 * comunque ripulita a parte (store + localStorage).
 */
export async function logout(): Promise<void> {
    await api.post('/logout');
}
